// extracted by mini-css-extract-plugin
export default {"summary":"EF","separator":"FF","title":"GF","note":"HF","items_wrapper":"IF","member_perk":"JF","info":"KF","extraQuestionsContain":"LF","h1":"MF","p":"NF","btn":"OF","stickyButton":"PF"};
    if(module.hot) {
      // 1730991508009
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  